var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleDone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_1379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.36453 0 0 3.36453 0 7.5C0 11.6355 3.36453 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.36453 11.6355 0 7.5 0ZM11.8292 6.05088L7.23007 10.1169C7.10573 10.2273 6.93942 10.2817 6.77388 10.2685C6.60939 10.2553 6.45474 10.1744 6.34956 10.0465L3.75026 6.87854L4.69864 6.1001L6.73218 8.57817C6.77466 8.62997 6.83632 8.66236 6.90315 8.66754C6.96999 8.67298 7.03604 8.65096 7.0863 8.6064L11.0161 5.13151L11.829 6.05088H11.8292Z",
    fill: "#85C26A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_1379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleDone);
export default __webpack_public_path__ + "static/media/icon-circle-done.ccd777fbc11fdbdc15b7910fe4a21887.svg";
export { ForwardRef as ReactComponent };